/**
 * Fixed credentials for the login screen's dev-only auto-login buttons
 * (`DevelopmentOnlyLoginPreview`) and the emulator seeder that creates the
 * matching accounts (`functions/seeder/runSeedPermitGateStudent.ts`).
 *
 * DEV / EMULATOR ONLY. These accounts exist only in the local Auth emulator;
 * the auto-login buttons render solely when `NODE_ENV === "development"`. Never
 * point these at production Auth.
 *
 * The password is `password1234` because both `seedUser` and `seedAdmin`
 * hardcode that value in the emulator — keep them in sync.
 */
export const DEV_LOGIN_PASSWORD = "password1234";

/** Eligible for the permit-exam gate (conditionally enrolled CDL, 11 lessons). */
export const DEV_STUDENT_LOGIN = {
  email: "permit-gate@example.com",
  password: DEV_LOGIN_PASSWORD,
} as const;

/**
 * NY student for the standalone `/permit-test` booking page: Manhattan profile
 * (defaults to the Harlem office), a date of birth on file, and zero practice
 * exams so the readiness floor (dates start two weeks out) is visible.
 */
export const DEV_PERMIT_BOOKING_LOGIN = {
  email: "permit-booking@example.com",
  password: DEV_LOGIN_PASSWORD,
} as const;

/**
 * NY student who already holds a confirmed DMV permit-test reservation (booked
 * job + CLP milestone + stored check-in barcode), for the Practice Hub's DMV
 * appointment card.
 */
export const DEV_DMV_APPOINTMENT_LOGIN = {
  email: "dmv-appointment@example.com",
  password: DEV_LOGIN_PASSWORD,
} as const;

/** Retention coach admin, so the admin console loads. */
export const DEV_ADMIN_LOGIN = {
  email: "dev-admin@example.com",
  password: DEV_LOGIN_PASSWORD,
} as const;

/** Partner used by the local referral/UTM dashboard demo seed. */
export const DEV_PARTNER_LOGIN = {
  email: "partner-utm@example.com",
  password: DEV_LOGIN_PASSWORD,
} as const;
